import React from "react";
import Form from "react-bootstrap/Form";

const SwTextArea = ({
  placeholder = "",
  rows = 3,
  className = "",
  onChange,
  value,
  defaultValue,
  ...rest
}) => {
  return (
    <Form.Control
      as="textarea"
      rows={rows}
      placeholder={placeholder}
      value={value}
      defaultValue={defaultValue}
      onChange={onChange}
      className={`SwFormTextArea ${className}`}
      {...rest}
    />
  );
};

export default SwTextArea;
